<template>
	<div class="module_page page_content institution" aria-label="Institution Reports view content page">

    <div class="row page-heading">
      <div class="col-7 input module_heading" role="heading" aria-level="1">
        <span class="module_icon icon-institution"></span>
        <label class="head_txt module_type_name institution-title ace_sec_hd">{{institution.displayName}}</label>
        <!-- <label class="head_txt module_type_name institution-title ace_sec_hd"><span v-if="advisorTitle">{{advisorTitle}}: </span>{{institution.title}}</label>
        <label class="head_txt module_type_name ace_sec_hd" v-if="showEntity"> <span class="separator">::</span> {{entity.title}}</label> -->
      </div>
      <div class="col-5 right-container">
      </div>
    </div>


	<div class="page_content_container">

         <template v-if="isNotCustomAdmin">
            <institution-menu :uuid="uuid" :active="'reports'"></institution-menu>
          </template>
          <template v-if="isCustomAdmin">
            <institution-menu-new :uuid="uuid" :active="'institutionReports'"></institution-menu-new>
          </template>

      	<div class="row pg_content">


				<div class="btn_container download_report">

					<b-dropdown
						variant="primary"
						right>

						<template #button-content>
					    <span class="fa fa-download mr-1"></span>
					    {{ $t('downloadReports') }}
					  </template>

						<b-dropdown-item
							v-if="isDownloadQuestionResponseEnabled"
							@click="downloadAsCsv">
								{{ $t('exportQuestionResponsesCsv') }}
						</b-dropdown-item>

						<b-dropdown-item
							v-if="isDownloadLearnerReportEnabled"
							@click="downloadAsCsvReport">
								{{ $t('exportLearnerReportCsv') }}
						</b-dropdown-item>

						<b-dropdown-item
							@click="downloadLocationAsCsvReport(false)">
								{{ $t('exportLearnerLocationsCsv') }}
						</b-dropdown-item>

						<b-dropdown-item
							@click="downloadLocationAsCsvReport(true)">
								{{ $t('exportLearnerLocationsCpsCsv') }}
						</b-dropdown-item>

						<b-dropdown-item
							@click="downloadAttemptsAsCsv('ALL')">
								{{ $t('constructedResponses') }}
						</b-dropdown-item>

						<b-dropdown-item
							@click="downloadAttemptsAsCsv('pending')">
								{{ $t('constructedResponsesGradingNeeded') }}
						</b-dropdown-item>

						<b-dropdown-divider></b-dropdown-divider>

						<b-dropdown-item
							v-if="isTestPrepReportEnabled"
							@click="openEmailReportModal">
								{{ $t('emailTestPrepProgressReport') }}
						</b-dropdown-item>

						<b-dropdown-item
							@click="openCourseActivityReportModal">
								{{ $t('emailCourseAggregatedActivityReport') }}
						</b-dropdown-item>

					</b-dropdown>

				</div>



				<!--
	        <div class="btn_container download_report" v-if="isDownloadQuestionResponseEnabled">
	          <button @click="downloadAsCsv">
	            <span class="fa fa-download" aria-hidden="true"></span>
	             Export Question Responses as CSV
	          </button>
	        </div>
	        <div class="btn_container download_report">
	          <button @click="downloadAsCsvReport">
	            <span class="fa fa-download" aria-hidden="true"></span>
	             Export Learner Report as CSV
	          </button>
	        </div>
	        <div class="btn_container download_report">
	          <button @click="downloadLocationAsCsvReport(false)">
	            <span class="fa fa-download" aria-hidden="true"></span>
	             Export Learner Locations Report as CSV
	          </button>
	        </div>
	        <div class="btn_container download_report">
	          <button @click="downloadLocationAsCsvReport(true)">
	            <span class="fa fa-download" aria-hidden="true"></span>
	             Export Learner Locations Report for CPs as CSV
	          </button>
	        </div>
	        <div class="btn_container download_report" v-if="isTestPrepReportEnabled">
	          <button @click="openEmailReportModal">
	            <span class="fa fa-download" aria-hidden="true"></span>
	             Email Test Prep Progress Report
	          </button>
	        </div>
	        <div class="btn_container download_report">
	          <button @click="openCourseActivityReportModal">
	            <span class="fa fa-download" aria-hidden="true"></span>
	             Email Course Aggregated Activity Report
	          </button>
	        </div>
	        <div class="btn_container download_report">
	          <button @click="downloadAttemptsAsCsv('ALL')">
	            <span class="fa fa-download" aria-hidden="true"></span>
	             Constructed Responses
	          </button>
	        </div>
	        <div class="btn_container download_report">
	          <button @click="downloadAttemptsAsCsv('pending')">
	            <span class="fa fa-download" aria-hidden="true"></span>
	             Constructed Responses Grading Needed
	          </button>
	        </div>
					-->

        	<div class="col-12">
	        	<div class="course-description">

							<report-list></report-list>

	        	</div>
	      	</div>
      	</div>

	</div>
    <div class="modal_popup_container course_unlock_modal">
      <b-modal ref="emailReportModal" class="description_modal" size="md" id="course-report-popup" hide-footer>
        <div slot="modal-header" class="header-section">
          <div class="head_txt" style="margin-top: 1px;">Test Prep Progress Report</div>
          <div class="btn_container">
            <button type="button" class="btn_close" @click="closeEmailReportModal" data-dismiss="modal" aria-label="Close">
              <span class="ic-close"></span>
            </button>
          </div>
        </div>

        <div class="row txt_row mt-3">
            Report will send to following Emails:
        </div>
        <div class="row txt_row mt-3">
            {{getTestPrepReportEmails}}
        </div>

        <div class="row mt-4">
          <div class="col-12 btn_container" style="text-align: right;">
            <b-button @click="closeEmailReportModal">cancel</b-button>
            <b-button @click="sendReport">send report</b-button>
          </div>
        </div>
      </b-modal>
    </div>
    <div>
      <b-modal ref="emailCourseActivittyModal" class="modal__v22_2 add_plan_modal course-activity-report-modal" id="course-activity-report-popup" :header-bg-variant="'subscribe-popup-header'" size="lg" no-close-on-backdrop no-close-on-esc>

        <div slot="modal-header" class="w-100">
          <div class="row align-items-center">
            <div class="col-2 hd">
              <div class="ic_container">
                <span class="ic ic22-reports"></span>
              </div>
            </div>
            <div class="col-8 hd">
              <div class="hd_txt txt_center activity-report-modal-title">
                Aggregated Course Activity Progress Report
              </div>
            </div>
            <div class="col-2 btn_container">
              <button class="btn_close" aria-label="Close" title="Close" @click="closeCourseActivityReportModal">
                <span class="ic-close"></span>
              </button>
            </div>
          </div>
        </div>

        <div class="row content_container">
          <div class="col-12 form_section">
            <div class="row price_plan_sec">
              <div class="col-12 sec_content">

                <div class="row sec_row fld_row">
                  <div class="col-12 fld_label">
                    <label class="label" for="activityReportEmail">Email</label>
                  </div>
                  <div class="col-12 fld_input">
                    <input id="activityReportEmail" v-model="eMail" type="email" aria-label="Email">
                  </div>
                </div>

                <div class="row sec_row fld_row">
                  <div class="col-12 fld_label">
                    <label class="label" for="startDate">Start Date</label>
                  </div>
                  <div class="col-12 fld_input">
                    <div class="datepicker-wrapper">
                      <span class="datepicker-icon ic_dateRange"></span>
                      <datepicker id="startDate" v-model="startDate" name="startDate"></datepicker>
                    </div>
                  </div>
                </div>

                <div class="row sec_row fld_row">
                  <div class="col-12 fld_label">
                    <label class="label" for="endDate">End Date</label>
                  </div>
                  <div class="col-12 fld_input">
                    <div class="datepicker-wrapper">
                      <span class="datepicker-icon ic_dateRange"></span>
                      <datepicker id="endDate" v-model="endDate" name="endDate"></datepicker>
                    </div>
                  </div>
                </div>

              </div>
            </div>
          </div>
        </div>

        <div slot="modal-footer" class="w-100">
          <div class="btn_container pr-3">
            <b-button @click="closeCourseActivityReportModal" class="btn">cancel</b-button>
            <b-button @click="sendActivityReport" class="btn">send report</b-button>
          </div>
        </div>
      </b-modal>
    </div>



	</div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import InstitutionMenu from './InstitutionMenu'
import InstitutionMenuNew from './InstitutionMenuNew'
import InstitutionHeader from './InstitutionHeader'
import Datepicker from 'vuejs-datepicker'
import { PACKAGE } from '../../../package_constants'
import ReportList from './ReportList'

export default {
  name: 'institutionReports',
  props: ['uuid'],
  components: {
    InstitutionMenu,
    InstitutionMenuNew,
    InstitutionHeader,
    ReportList,
    Datepicker
  },
  data: () => {
    return {
      uObj: JSON.parse(localStorage.getItem('userobj')),
      userrole: localStorage.getItem('userrole'),
      startDate:undefined,
      endDate:undefined,
      eMail: ''

    }
  },
  mounted () {
    this.loadInstitution()
  },
  methods: {
    ...mapActions([
      'loadInstitutionDetail',
      'loadUserAdvisor',
      'loadLogDashboardActivity',
      'downloadAnswersAsCsv',
      'downloadLearnerReport',
      'downloadCRAsCsv',
      'downloadLearnerLocationReport',
      'sendTestPrepProgressReport',
      'sendCourseAggProgressReport'
    ]),

    loadInstitution () {
      this.loadLogDashboardActivity({action: 'viewInstitutionReportsView', page: 'institutionReportsView', link: '', entityUuid: this.uuid})
      this.loadInstitutionDetail(this.uuid)
    },
    writeFile (data, fileName) {
      const blob = new Blob([data], {type: 'text/plain'})
      const e = document.createEvent('MouseEvents')
      let a = document.createElement('a')
      a.download = fileName
      a.href = window.URL.createObjectURL(blob)
      a.dataset.downloadurl = ['text/json', a.download, a.href].join(':')
      e.initEvent('click', true, false, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null)
      a.dispatchEvent(e)
    },
    notifySuccess (text) {
      this.$notify({
        group: 'notify',
        type: 'success',
        title: '',
        text: text
      })
    },
    notifyFailure (text) {
      this.$notify({
        group: 'notify',
        type: 'error',
        title: '',
        text: text
      })
    },
    notifyWarning (text) {
      this.$notify({
        group: 'notify',
        type: 'warn',
        title: '',
        text: text
      })
    },
    getFormattedTime() {
        var today = new Date();
        var y = today.getFullYear();
        // JavaScript months are 0-based.
        var m = today.getMonth() + 1;
        var d = today.getDate();
        var h = today.getHours();
        var mi = today.getMinutes();
        var s = today.getSeconds();
        return y + "-" + m + "-" + d + "-" + h + "-" + mi + "-" + s;
    },
    downloadAttemptsAsCsv (type) {
    this.showLoader()
      this.downloadCRAsCsv(type).then(response => {
        let qaCsvFile = response && response.fileContents ? response.fileContents : response
        let errors = response && response.error ? response.error : ''
        let warnings = response && response.warning ? response.warning : ''
        if (!qaCsvFile || !qaCsvFile.length || qaCsvFile.length === 0) {
          return this.notifyFailure(errors)
        }
        let fileName = (type==='pending')?'CR Grading Needed':'CR Grading'

        this.writeFile(qaCsvFile, fileName + '-'+this.getFormattedTime()+'.csv')
        this.hideLoader()
        if (warnings && warnings.length > 0) {
          this.notifyWarning(warnings)
        } else {
          this.notifySuccess('Constructed Responses Successfully Exported to Csv')
        }
      })
    },
    downloadAsCsv () {
    this.showLoader()
      this.downloadAnswersAsCsv().then(response => {
        let qaCsvFile = response && response.fileContents ? response.fileContents : response
        let errors = response && response.error ? response.error : ''
        let warnings = response && response.warning ? response.warning : ''
        if (!qaCsvFile || !qaCsvFile.length || qaCsvFile.length === 0) {
          return this.notifyFailure(errors)
        }
        this.writeFile(qaCsvFile, 'QuestionResponses.csv')
        this.hideLoader()
        if (warnings && warnings.length > 0) {
          this.notifyWarning(warnings)
        } else {
          this.notifySuccess('QuestionResponses Successfully Exported to Csv')
        }
      })
    },
    showLoader () {
        if (this.$parent.$refs.loadingModal) {
          this.$parent.$refs.loadingModal.show()
        }
      },
    hideLoader () {
        if (this.$parent.$refs.loadingModal) {
          this.$parent.$refs.loadingModal.hide()
        }
      },
    downloadAsCsvReport () {
      this.showLoader()
      this.downloadLearnerReport().then(response => {
        let qaCsvFile = response && response.fileContents ? response.fileContents : response
        let errors = response && response.error ? response.error : ''
        let warnings = response && response.warning ? response.warning : ''
        if (!qaCsvFile || !qaCsvFile.length || qaCsvFile.length === 0) {
          return this.notifyFailure(errors)
        }
        this.writeFile(qaCsvFile, 'LearnerReport.csv')
        this.hideLoader()
        if (warnings && warnings.length > 0) {
          this.notifyWarning(warnings)
        } else {
          this.notifySuccess('Learner Report Successfully Exported to Csv')
        }
      })
    },
    closeEmailReportModal (){
      this.$refs.emailReportModal.hide()
    },
    closeCourseActivityReportModal(){
      this.$refs.emailCourseActivittyModal.hide()
    },
    openEmailReportModal (course, unlocked) {
      this.$refs.emailReportModal.show()
    },
    openCourseActivityReportModal (){
      this.$refs.emailCourseActivittyModal.show()
    },
    sendActivityReport(){
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if(!this.eMail || !emailRegex.test(this.eMail)){
          this.notifyFailure('Please enter valid Email.')
          return
        }
        if(!this.startDate || !this.endDate){
          this.notifyFailure('Start and End Date are Required')
          return
        }
        var sDate = new Date(this.startDate)
        var eDate = new Date(this.endDate)
        if (sDate > eDate) {
          this.notifyFailure('End Date must be greater than Start Date.')
          return
          }
        this.sendCourseAggProgressReport({startDate:sDate, endDate:eDate, email:this.eMail})
        this.$refs.emailCourseActivittyModal.hide()
        this.notifySuccess('The report is being processed and emails will be sent shortly.')
    },
    sendReport () {
        this.sendTestPrepProgressReport()
        this.$refs.emailReportModal.hide()
        this.notifySuccess('The report is being processed and emails will be sent shortly.')
    },


    downloadLocationAsCsvReport (flag) {
      let flagValue = flag?true:false;
      this.showLoader()
      this.downloadLearnerLocationReport(flagValue).then(response => {
        let qaCsvFile = response && response.fileContents ? response.fileContents : response
        let errors = response && response.error ? response.error : ''
        let warnings = response && response.warning ? response.warning : ''
        if (!qaCsvFile || !qaCsvFile.length || qaCsvFile.length === 0) {
          return this.notifyFailure(errors)
        }
        this.writeFile(qaCsvFile, 'LearnerLocationReport.csv')
        this.hideLoader()
        if (warnings && warnings.length > 0) {
          this.notifyWarning(warnings)
        } else {
          this.notifySuccess('Learner Location Report Successfully Exported to Csv')
        }
      })
    }

  },
  computed: {
    ...mapState({
      'institution': state => state.institution.institution,
      'enabledFeatures': state => state.institution.enabledFeatures
    }),
    isDownloadQuestionResponseEnabled () {
        let profileFeature = this.enabledFeatures[PACKAGE.FEATURE_IDS.PROFILE_FEATURE_ID]
        if (profileFeature && profileFeature.enabled) {
          let flags = profileFeature.flags
          let found = _.find(flags, (flag) => {
            return (flag.title === 'allowDownloadQuestionResponses')
          })
          return found ? found.enabled : false
        }
      return false
    },
    isTestPrepReportEnabled () {
        let learnerDBFeature = this.enabledFeatures['learner_dashboard']
        if (learnerDBFeature && learnerDBFeature.enabled) {
          let flags = learnerDBFeature.flags
          let found = _.find(flags, (flag) => {
            return (flag.title === 'Weekly Test Prep Progress Mail')
          })
          return found ? found.enabled : false
        }
      return false
    },
    getTestPrepReportEmails () {
        let learnerDBFeature = this.enabledFeatures['learner_dashboard']
        if (learnerDBFeature && learnerDBFeature.enabled) {
          let flags = learnerDBFeature.flags
          let found = _.find(flags, (flag) => {
            return (flag.title === 'Weekly Test Prep Progress Mail')
          })
          return found ? found.label : ""
        }
      return ""
    },

    isCustomAdmin () {
      let currentUser = JSON.parse(localStorage.getItem('userobj'))
      return (currentUser && currentUser.customAdmin)
    },
    isNotCustomAdmin () {
      let currentUser = JSON.parse(localStorage.getItem('userobj'))
      return !(currentUser && currentUser.customAdmin)
    },
    isDownloadLearnerReportEnabled () {
        let profileFeature = this.enabledFeatures[PACKAGE.FEATURE_IDS.SHOW_LEARNER_DASHBOARD_FEATURE_ID]
        if (profileFeature && profileFeature.enabled) {
          let flags = profileFeature.flags
          let found = _.find(flags, (flag) => {
            return (flag.title === 'Download Learner Report')
          })
          return found ? found.enabled : false
        }
      return false
    }


  }
}
</script>

<style>
.course-activity-report-modal .modal-body {
  overflow: visible;
  min-height: 320px;
  padding-left: 0;
  padding-right: 0;
}

.course-activity-report-modal .content_container {
  max-width: 420px;
  min-width: 320px;
  margin: 0 auto;
  padding: 10px 24px 0;
  float: none;
}

.course-activity-report-modal .form_section {
  padding: 0;
}

.course-activity-report-modal .modal-header .ic_container .ic22-reports {
  font-size: 38px;
  margin-top: -4px;
  display: block;
}

.course-activity-report-modal .activity-report-modal-title {
  white-space: nowrap;
  font-size: 17px;
  line-height: 1.2;
  text-align: center;
  width: 100%;
  margin: 0;
  padding: 0 8px;
}

.course-activity-report-modal .datepicker-wrapper {
  width: 100%;
  max-width: 100%;
  margin-top: 0;
}

.course-activity-report-modal .vdp-datepicker {
  width: 100%;
}

.course-activity-report-modal .vdp-datepicker__calendar {
  z-index: 1060;
}
.btn_container.download_report {
	position: absolute;
	z-index: 2;
	right: 30px;
	top: 61px;
	width: 210px !important;
	text-align: right;
}
.btn_container.download_report button {
	padding: 6px 12px !important;
	margin-right: 2px;
}
.reports_container .reports_filter {
	right: 35px !important;
}
</style>



// WEBPACK FOOTER //
// src/app/institution/components/InstitutionReports.vue